export default {
  namespaced: true,
  state: {
    showSaveSearchButton: false,
    publishedFromDate: '',
    publishedToDate: '',
    newPublishedFromDate: '',
    newPublishedToDate: '',  
    excelExportFilePreName: '',
    lightAccess: false,
    fullAccess: false,
    advertiserAccess: false,
    ssasInfo: {},
    anyFormFieldsLoaded: false,
    activeTab: null,
    internalAndMMSOnly: false,
    dataLogMessage: '',
    obsMessage: '',
    expandSavedSearchesSidebar: false
  },
  getters: {
    getShowSaveSearchButton: state => state.showSaveSearchButton,
    getPublishedFromDate: state => state.publishedFromDate,
    getPublishedToDate: state => state.publishedToDate,
    getNewPublishedFromDate: state => state.NewPublishedFromDate,
    getNewPublishedToDate: state => state.newPublishedToDate,
    getAnyFormFieldsLoaded: state => state.anyFormFieldsLoaded,
    getActiveTab: state => state.activeTab,
    getDataLogMessage: state => state.dataLogMessage,
    getObsMessage: state => state.obsMessage,
    getExpandSavedSearchesSidebar: state => state.expandSavedSearchesSidebar
  },
  mutations: {
    updateShowSaveSearchButton(state, value) {
      state.showSaveSearchButton = value;
    },
    updateAdvertiserAccess: (state, payload) => state.advertiserAccess = payload,
    updateLightAccess(state, value) {
      state.lightAccess = value;
    },
    updateFullAccess(state, value) {
      state.fullAccess = value;
    },
    updatePublishedFromDate(state, value) {
      state.publishedFromDate = value;
    },
    updatePublishedToDate(state, value) {
      state.publishedToDate = value;
    },
    updateNewPublishedFromDate(state, value) {
      state.NewPublishedFromDate = value;
    },
    updateNewPublishedToDate(state, value) {
      state.NewPublishedToDate = value;
    },
    updateAdPublishedFromDate(state, value) {
      state.adPublishedFromDate = value;
    },
    updateExcelExportFilePreName(state, value) {
      state.excelExportFilePreName = value;
    },
    updateExcelExportTextInFile(state, value) {
      state.excelExportTextInFile = value;
    },
    updateSSASInfo(state, value) {
      state.ssasInfo = value;
    },
    updateAnyFormFieldsLoaded(state, value) {
      state.anyFormFieldsLoaded = value;
    },
    updateActiveTab(state, value) {
      state.activeTab = value;
    },
    updateInternalAndMMSOnly(state, value) {
      state.internalAndMMSOnly = value;
    },
    updateDataLogMessage(state, value) {
      state.dataLogMessage = value;
    },
    updateObsMessage(state, value) {
      state.obsMessage = value;
    },
    updateExpandSavedSearchesSidebar(state, value) {
      state.expandSavedSearchesSidebar = value;
    }
  },
};
